import { render, staticRenderFns } from "./InformacionLocal.vue?vue&type=template&id=93aba1a6&"
import script from "./InformacionLocal.vue?vue&type=script&lang=js&"
export * from "./InformacionLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports